export enum GenderEnum {
  'Mr' = 'male',
  'Ms' = 'female'
}
